import { render, staticRenderFns } from "./CompaniesRequests.vue?vue&type=template&id=2111fd12&"
import script from "./CompaniesRequests.vue?vue&type=script&lang=ts&"
export * from "./CompaniesRequests.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports